import LoadingCover from './loadingCover'

export default LoadingCover
